import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import MyDialog from '@/components/MyDialog.vue';
import VueMarkdown from 'vue-markdown';
import { range } from 'lodash';
import MySelect from '@/components/MySelect.vue';
import CharacterSheetMenuButton from './CharacterSheetMenuButton.vue';
const conditionsModule = namespace('conditions');
let CharacterSheetConditions = class CharacterSheetConditions extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.range = range;
    }
    updateConditions(newConditions) {
        let newExhaustion;
        if (newConditions.includes('Exhaustion') && !this.exhaustion)
            newExhaustion = 1;
        if (!newConditions.includes('Exhaustion'))
            newExhaustion = 0;
        this.$emit('replaceCharacterProperties', [
            { path: 'currentStats.conditions', property: newConditions },
            { path: 'currentStats.exhausion', property: newExhaustion }
        ]);
    }
};
__decorate([
    Prop(Array)
], CharacterSheetConditions.prototype, "myConditions", void 0);
__decorate([
    Prop(Number)
], CharacterSheetConditions.prototype, "exhaustion", void 0);
__decorate([
    conditionsModule.State
], CharacterSheetConditions.prototype, "conditions", void 0);
CharacterSheetConditions = __decorate([
    Component({
        components: {
            MyDialog,
            VueMarkdown,
            MySelect,
            CharacterSheetMenuButton
        }
    })
], CharacterSheetConditions);
export default CharacterSheetConditions;
